module.exports = "/fonts/vendor/summernote/dist/summernote.woff?7222f2aa6fc35e05281c7aa793342870";


//////////////////
// WEBPACK FOOTER
// ./~/summernote/dist/font/summernote.woff
// module id = 88
// module chunks = 0